import "../../index.css";
import "./directoryButton.css";
import ButtonCover from "../ButtonCover/ButtonCover";
import { useNavigate } from "react-router-dom";
import BoldText from "../BoldText/BoldText";

function DirectoryButton({link, title, iconClass, light=false, last=false, class_Name}) {

  
  const navigate = useNavigate();

  const handleClick = () => {
    // Check if the URL starts with http:// or https://
    const isExternal = link.startsWith('http://') || link.startsWith('https://');

    if (isExternal) {
      // Use native browser navigation for external links
      window.location.href = link;
    } else {
      // Use React Router for local/internal links
      navigate(link);
    }
  };
  
    return (
    <ButtonCover onClick={()=>handleClick(link)} visible={true} bg={light ? "bg-light-green" : "bg-dark-blue"}  class_Name={class_Name}  >
        <div className= {`flex-row-apart directory-btn-inner ${class_Name} `}>
          <div  className={"icon-title-combo"} >
            <i className={`${iconClass} font-size-3 icon-mr ${light ? "clr-light" : "clr-dark"}`} style={{fontWeight: "bold"}}></i>
            <BoldText class_Name={`font-size-3 ${light ? "clr-light" : "clr-dark"}`}>{title}</BoldText>
          </div> 
        <i className="fa-solid fa-chevron-right font-size-3" style={{ color: light ? "white" : "black"}}></i>
     </div>

    </ButtonCover>
  );
}

export default DirectoryButton;